<div class="color-options transition" [ngClass]="{'show': showOptions}">
    <div class="card-title-text fx-row-wrap fx-main-between fx-cross-center">
        <h4 class="fw-500">Configuration</h4>
        <button class="card-control" mat-icon-button href="javascript:void(0)" (click)="showOptions = !showOptions">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="configuration-content">
        <div class="setting-contant">
            <h6 _ngcontent-oma-c131="" class="title text-muted">Layout Type</h6>
            <div class="dark-light" (click)="customizeLayoutDark()">
                <div class="theme-layout-version"  >{{buttonName}}</div>
            </div>

        </div>
        <div class="setting-contant" [class.opensubmenu]="isActive('color option')">
            <h6 _ngcontent-oma-c131="" class="title text-muted">Theme Colors</h6>
            <ul class="color-box">
                <li>
                    <input id="colorPicker1" type="color" value="#ef6c00" name="Background"
                        (change)="customizeThemeColor($event)">
                    <span>theme deafult color</span>
                </li>
            </ul>
        </div>
    </div>

    <a href="javascript:void(0)">
        <div (click)="showOptions = !showOptions" class="options-icon">
            <mat-icon>settings</mat-icon>
        </div>
    </a>
</div> 